import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import MasonAIChat from "@/components/MasonAIChat";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-spa-cream flex flex-col">
      <Navigation />
      <main className="flex-1">{children}</main>
      <Footer />
      <MasonAIChat />
    </div>
  );
}
